import React,{useState,useEffect} from 'react' 
import { IoIosSearch } from "react-icons/io";
 import Popover from '../admin/shared/Popover';
import { useNavigate,Link  } from 'react-router-dom';
import RedeemedItems from './shared/RedeemedItems';
import DatePicker from "react-datepicker";
import { FaRegCalendarAlt } from "react-icons/fa";
import "react-datepicker/dist/react-datepicker.css";
import config from '../config';
import axios from 'axios';
import { BsExclamationCircle } from "react-icons/bs";
import { APPROVE_REDEEM_POINTS, DASHBOARD } from '../common/constants';
import { IoIosArrowBack,IoIosArrowForward } from "react-icons/io";
import { RiShoppingBagLine } from "react-icons/ri";
import { MdPlumbing } from "react-icons/md";
import { HiOutlineUser } from "react-icons/hi";
import { BsQrCodeScan } from "react-icons/bs";
import { TbReportSearch } from "react-icons/tb";
import { MdOutlineFormatListBulleted } from "react-icons/md"; 
import { HiOutlineArrowCircleDown } from "react-icons/hi";
import Pagination from '../common/Pagination';



function Dashboard() {

  const [statistics, setStatictics] = useState([]);
  const [selectedPopoverId, setSelectedPopoverId] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [approveAll, setApproveAll] = useState(false);
  const [custmerCount,setCustomersCount] = useState(0);
  const [qrCount,setqrCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);


  const [selected, setSelected] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [redeemPoints, setSelectedRedeemPoints] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);

    const [formData, setFormData] = useState({
      startDate: null,
      endDate: null,
      search: '',
    });
  

      useEffect(() => {
        // Fetch data from the API
       
        // getRedeemRecords();
        getDashBoardData();
    
    
      }, []); // Empty dependency array means this effect runs only once on component mount
      useEffect(() => {
      
          getRedeemRecords();
      
      }, [formData.startDate, formData.endDate, formData.search, currentPage]); // Add currentPage here
      const getRedeemRecords = () => {
        const payload = {
          ...formData,
          page: currentPage + 1, // API expects 1-based page numbers
          limit: itemsPerPage
        };
        
        axios.post(`${config.backendUrl}/admin/scanners/scanned-qr-data`, payload, {
          headers: {
            'token': localStorage.getItem('token'),
            'Content-Type': 'application/json',
          }
        })
        .then(response => {
          setStatictics(response.data.data);
          setTotalPages(response.data.total_pages);
        })
        .catch(error => {
          console.error('Error:', error);
        });
      }

      const getDashBoardData = ()=>{
        axios.post(DASHBOARD,{}, {
          headers: {
            'token': localStorage.getItem('token'), // Example authorization header
            'Content-Type': 'application/json', // Example content type header
            // Add more headers as needed
          }
          })
        .then(response => {
          // Handle response
       
           setCustomersCount(response.data.data.customers);
           setqrCount(response.data.data.qrCount);
         
         
        })
        .catch(error => {
          // Handle error
          console.error('Error:', error);
        });
      }
     

      const handleOpenPopover = (id,redeem_points) => {
        setSelectedPopoverId(id);
        setSelectedRedeemPoints(redeem_points);
      };

      const OpenApproveSelectedPopUp=()=>{

       
        setApproveAll(true);
        

      }
    
      const handleClosePopover = () => {
        getRedeemRecords();
        setSelectedPopoverId(null);
      };

 
  
    
     
      const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
      };
  

      function handleChange(date, fieldName) {
        setFormData(prevState => ({
          ...prevState,
          [fieldName]: date
        }));
      }
      
      function handleSearchChange(event) {
       
        const { name, value } = event.target;
        setFormData(prevState => ({
          ...prevState,
          [name]: value
        }));
      }
      
  
      
      // Use filteredItems instead of data for pagination
      const currentItems = statistics.slice(
        currentPage * itemsPerPage,
        (currentPage + 1) * itemsPerPage
      );

      const renderPageNumbers = () => {
        let pages = [];
        for (let i = 0; i < totalPages; i++) {
            let isActive = currentPage === i;
          pages.push(
            <button
              key={i}
              style={{ margin: 5 }}
              onClick={() => handlePageChange(i)}
              className={isActive ? 'active' : ''}
              disabled={currentPage === i}
            >
              {i + 1}
            </button>
          );
        }
        return pages;
      };
      const navigate = useNavigate();
      const goToProductList = () => {
        navigate('/admin/products');
    };
    const gotoPlumber = () => {
        navigate('/admin/plumbers');
    };
    const gotoCustomers = () => {
        navigate('/admin/customers');
    };
    const gotoQrList = () => {
        navigate('/admin/qrlist');
    };
    const gotoGeneratedQrList = () => {
      navigate('/admin/generated-qrs');
  };
  const goToWithDrawalReports = () => {
      navigate('/admin/withdrawl-reports');
  };
    const gotoQrGenerate = () => {
        navigate('/admin/qrgenerate');
    };
    const gotoReports = () => {
        navigate('/admin/reports');
    };
    const goToModelsList = () => {
      navigate('/admin/models');
  };
  const goToLocations =() =>{
    navigate('/admin/locations');
  }
   
    // Function to handle individual checkbox selection
  const handleCheckboxChange = (id) => {
    const newSelectedIds = selectedIds.includes(id)
      ? selectedIds.filter((selectedId) => selectedId !== id)
      : [...selectedIds, id];
    setSelectedIds(newSelectedIds);
  };
     // Function to handle "Check All" checkbox selection
  const handleCheckAllChange = () => {
    if (selectAll) {
      setSelectedIds([]);
    } else {
      const allIds = currentItems.map((item) => item.transaction_id);
      setSelectedIds(allIds);
    }
    setSelectAll(!selectAll);
  };
  
  const handleCloseApproveAllPopover=()=>{

    getRedeemRecords();
    setApproveAll(false);

  }
  const approveSelectedRecords =()=>{
    const transactionIdsString = selectedIds.join(',');
      // Fetch data from the API
      axios.post(APPROVE_REDEEM_POINTS,{'transaction_id':transactionIdsString}, {
        headers: {
          'token': localStorage.getItem('token'), // Example authorization header
          'Content-Type': 'application/json', // Example content type header
          // Add more headers as needed
        }
        })
    .then(response => {
      // Handle response
      getRedeemRecords();
      handleCloseApproveAllPopover();
      setSelectAll(false);
     
     
    })
    .catch(error => {
      // Handle error
      console.error('Error:', error);
    });
  }
  return (
    <> 
      <div className="pt-[70px]">
     <div className='mt-4 mb-2'> <h2>Dashboard</h2>     </div>
          
         {/* <div className='breadcrumbs'> <Link to="/admin/dashboard">Home</Link> </div> */}
    <div className="categories-list">
      <div  onClick={goToModelsList} className='categories-box'>       
            <div className='flex justify-end'> 
            <RiShoppingBagLine /> 
         </div>
            <h4>Our Models</h4>
        </div>
        <div  onClick={goToProductList} className='categories-box'>       
            <div className='flex justify-end'> 
            <RiShoppingBagLine /> 
         </div>
            <h4>Our Products</h4>
        </div>

        <div onClick={gotoPlumber} className='categories-box'>
            <div className='flex justify-end'> 
            <MdPlumbing />
       </div>
            <h4>Plumbers</h4>
        </div>

        <div onClick={gotoCustomers} className='categories-box'>
            <div className='flex justify-end'>
              <HiOutlineUser /> 
       </div>
            <h4>Customers</h4>
        </div>

        <div  onClick={gotoGeneratedQrList} className='categories-box'>
            <div className='flex gap-4 items-center'> 
                <div className='redcircle'>{qrCount} </div>
                <div style={{fontSize:"16px"}}>QR’s  <br/>  Generated</div>
            </div>
        </div>
        {/* <div  onClick={goToWithDrawalReports} className='categories-box'>
            <div className='flex gap-4 items-center'> 
                  <div className='flex justify-end'>
                     <HiOutlineUser /> 
                  </div>
                <h4>Withdrawl Reports</h4>
            </div>
        </div> */}
          <div onClick={goToWithDrawalReports} className='categories-box'>
            <div className='flex justify-end'>
              <HiOutlineArrowCircleDown /> 
          </div>
            <h4>Withdrawal Reports</h4>
        </div>


        <div  onClick={gotoQrGenerate} className='categories-box'>
            <div className='flex justify-end'> 
              <BsQrCodeScan /> 
            </div>
            <h4>Generate QR</h4>
        </div>

        <div  onClick={gotoReports} className='categories-box'>
            <div className='flex justify-end'> 
             <TbReportSearch />
            </div>
            <h4>Reports</h4>
        </div>

        <div   onClick={gotoQrList}  className='categories-box'>
            <div className='flex justify-end'>
               <MdOutlineFormatListBulleted  /> 
            </div>
            <h4>QR Batch List</h4>
        </div>

            <div   onClick={goToLocations}  className='categories-box'>
            <div className='flex justify-end'>
               <MdOutlineFormatListBulleted  /> 
            </div>
            <h4>Locations</h4>
        </div>


    </div>
    
    <div  className='whitebox'>
    <form>
        <div className='flex justify-between mb-4'> 
        <h4> Statistics</h4>
        <div className='flex gap-4'>  
            
            <div className="date-filters flex">
            
          
          <div className='flex items-center border px-4'><DatePicker 
              selected={formData.startDate} 
              onChange={(date) => handleChange(date, 'startDate')}
              name="startDate" 
             
              placeholderText="From date"
            /> <FaRegCalendarAlt /></div>

         
           <div className='flex items-center border px-4'><DatePicker 
              selected={formData.endDate} 
              onChange={(date) => handleChange(date, 'endDate')}
              name="endDate" 
              placeholderText="To date" 
            /><FaRegCalendarAlt />
          </div>

         
        </div>
     
  
      <div className='flex table-search'>   
      <input
          type="text"
          placeholder="Search"
          value={formData.search}
          name="search"
          onChange={handleSearchChange}
        />
        <IoIosSearch />

      </div>
    </div>
    
</div>
</form>

    <div>
      <table className='tablegrid table-auto w-full border-collapse border' width={"100%"}>
        <thead>
          <tr className="bg-gray-100 text-left">
            <th className="px-4 py-4 font-medium text-center" ><input type="checkbox"      checked={selectAll}
                onChange={handleCheckAllChange} /></th>
            <th className="py-4 font-medium">S.No</th>
            {/* <th className="px-4 py-4 font-medium">UserType</th> */}
            <th className="px-4 py-4 font-medium">UserName</th>
            <th className="px-4 py-4 font-medium">PhoneNumber</th>
            <th className="px-4 py-4 font-medium">Model</th>
            <th className="px-4 py-4 font-medium">ProductName</th>
            <th className="px-4 py-4 font-medium">Reward Points</th>
            
            <th className="px-4 py-4 font-medium">Scanned Date</th>
          
           
           
            {/* <th>Approve Rewards</th> */}
          </tr>
        </thead>
        <tbody>
        {statistics.length === 0 ? (
          <tr>
            <td colSpan="8" align="center">No records available</td>
          </tr>
        ) : (
          statistics.map((item, index) => (
            <tr key={index}>
              <td className="px-4 py-4 align-middle text-center"><input type="checkbox" checked={selectedIds.includes(item.transaction_id)} onChange={() => handleCheckboxChange(item.transaction_id)} /></td>
              <td >{item.sno}</td>
              <td className=''>{item.user_name}</td>
              <td>{item.phone_number}</td>
              <td>{item.model_name}</td>
              <td>{item.product_name}</td>
              <td>{item.reward_points}</td> 
              <td>{item.scanned_date}</td>
            </tr>
          ))
        )}
      </tbody>
      </table>

      <div className='flex justify-between mt-4'>
      {/* {currentItems.length !== 0 && (
      <button type="button" className='redbtn' onClick={OpenApproveSelectedPopUp}>Approve All</button>
    )} */}
        <div></div>
        <div className='pagenation'> 
        
        </div>
           <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
             />
      </div>
    </div>

    </div>

    {selectedPopoverId && (
          <Popover onClose={handleClosePopover}  isVisible={selectedPopoverId !== null}>
            <RedeemedItems  onClose={handleClosePopover}  transactionId={selectedPopoverId} redeemPoints={redeemPoints} ></RedeemedItems>
          

          </Popover>
        )}

    {approveAll && (
    <Popover onClose={handleCloseApproveAllPopover}  isVisible={approveAll !== null}>
           
                     
    <div className="flex  justify-center okicon"> 
    <BsExclamationCircle />

    </div>  
    <div className='flex justify-center items-center text-center' style={{flexDirection:"column"}}> 
    
    <h4>Are you sure want to approve  ? <br/> 
    </h4>
<div className='flex items-center justify-center gap-4 mt-5' >
<button  onClick={handleCloseApproveAllPopover} className='greybtn'>NO</button>
    <button onClick={approveSelectedRecords}  className='redbtn'>YES</button>

</div>
  

    </div> 

          </Popover>
        )} 
      </div>
    </>
  )
}

export default Dashboard
